module.exports = __webpack_public_path__ + "img/LUB00289.8d1ba283.png";